import React, { useState, useEffect, useRef } from "react";
import { Tabs, Tab, Row, Col, Nav, Button } from "react-bootstrap";
import { Modal } from "antd";
import "../../App.css";
import "./RateQuote.css";
import "./RateQuoteNew.css";
import SearchBox from "./components/search/index";
import RightDrawer from "./components/search/rightDrawer";
import { withRouter } from "react-router-dom";
import RateQuoteLOVersion from "./RateQuoteLOVersion";
import RateQuoteLONewVersion from "./RateQuoteLONewVersion";
import RateQuoteBorrowerVersion from "./RateQuoteBorrowerVersion";
import { checkAccess } from "../../Auth";
import { UR_PriceEngineUser, UR_Owner } from "../../State";
import Lenders from "../../Management/Lenders";

const RateQuoter = (props) => {
  const [showAddLenderModal, setShowAddLendersModal] = useState(false);
  const [switchkey, setSwitchkey] = useState("loVersion");
  const [rightDrawer, setRightDrawer] = useState(false);
  const [addLenderModal, setAddLenderModal] = useState(false);
  const [params, setParams] = useState({});
  const isMobile = window.innerWidth < 576;
  if (checkAccess([UR_PriceEngineUser])) {
    return <RateQuoteLONewVersion />;
  }

  const openRightDrawer = () => {
    console.log("open right drawer");
    setRightDrawer(true);
  };

  const openAddLenderModal = () => {
    setAddLenderModal(true);
  };

  var currentUrl = window.location.href;
  const isGMCCCelebrity =
    currentUrl.includes("gmcccelebrityrates") || props.isGMCCCelebrity;
  const specificProgram =
    isGMCCCelebrity || props.isGMCCCelebrity ? "GMCCCelebrities" : undefined;

  let content = (
    <Tab.Container
      defaultActiveKey="loVersion"
      onSelect={(activekey) => setSwitchkey(activekey)}
    >
      <Row
        style={{
          borderBottom: "1px solid #DBDCDE",
          height: 62,
          alignItems: "center",
        }}
      >
        <Col xs={6} style={{ paddingLeft: 26 }}>
          {!isMobile && (
            <div
              style={{
                fontWeight: 500,
                textAlign: "left",
                fontSize: "18px",
                color: "#222",
              }}
            >
              Rates
            </div>
          )}
        </Col>
        {!isGMCCCelebrity && (
          <Col xs={6}>
            <Nav
              style={{
                justifyContent: "right",
                paddingRight: isMobile ? "0" : "20px",
                fontFamily: "Inter",
              }}
            >
              <Nav.Item className="d-flex" style={{ alignItems: "center" }}>
                {switchkey === "borrowerVersion" && (
                  <Nav.Link
                    style={{
                      backgroundColor: "#F6F6F6",
                      display: "flex",
                      padding: 3,
                      alignItems: "center",
                      gap: 4,
                      borderRadius: "6px",
                      height: 40,
                    }}
                    eventKey="loVersion"
                  >
                    <div
                      style={{
                        width: 130,
                        height: 34,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "14px",
                        color: "#222222",
                      }}
                    >
                      LO version
                    </div>
                    <div
                      style={{
                        width: 130,
                        height: 34,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#FFFFFF",
                        borderRadius: 4,
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#222",
                        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.06)",
                      }}
                    >
                      Borrower version
                    </div>
                  </Nav.Link>
                )}
                {switchkey === "loVersion" && (
                  <Nav.Link
                    style={{
                      backgroundColor: "#F6F6F6",
                      display: "flex",
                      padding: 3,
                      alignItems: "center",
                      gap: 4,
                      borderRadius: "6px",
                      height: 40,
                    }}
                    eventKey="borrowerVersion"
                  >
                    <div
                      style={{
                        width: 130,
                        height: 34,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#FFFFFF",
                        borderRadius: 4,
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#222",
                        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.06)",
                      }}
                    >
                      LO version
                    </div>
                    <div
                      style={{
                        width: 130,
                        height: 34,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "14px",
                        color: "#222222",
                      }}
                    >
                      Borrower version
                    </div>
                  </Nav.Link>
                )}
                {checkAccess([UR_Owner]) && (
                  <Button
                    variant="addLenders"
                    className="addLendersBtn addLendersBtn-new"
                    onClick={() => openAddLenderModal(true)}
                  >
                    Add lenders
                  </Button>
                )}
                {switchkey !== "borrowerVersion" && (
                  <div
                    style={{ marginLeft: 8 }}
                    className="rate-quote-new-header-btn cursor-pointer"
                    onClick={openRightDrawer}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M9.99951 6.66667V10L11.6662 11.6667M2.54102 9.16672C2.72776 7.33344 3.5829 5.63307 4.94329 4.39003C6.30368 3.14699 8.07409 2.44829 9.91675 2.42725C11.7594 2.4062 13.5453 3.06428 14.9337 4.27592C16.3222 5.48756 17.2159 7.16796 17.4445 8.9965C17.6731 10.825 17.2204 12.6737 16.173 14.1899C15.1255 15.706 13.5566 16.7834 11.7654 17.2166C9.97428 17.6498 8.08636 17.4084 6.46185 16.5384C4.83733 15.6685 3.58995 14.231 2.95768 12.5001M2.54102 16.6667V12.5001H6.70768"
                        stroke="#325CEB"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                )}
              </Nav.Item>
            </Nav>
          </Col>
        )}
      </Row>

      <Tab.Content
        style={{ height: "calc(100vh - 62px)", overflowY: "scroll" }}
        className="rate-quote-new"
      >
        <Tab.Pane className="h-100" eventKey="loVersion">
          {" "}
          <div className="rate-quote-new-content">
            <SearchBox params={params} />
          </div>
        </Tab.Pane>
        <Tab.Pane className="h-100" eventKey="borrowerVersion">
          <RateQuoteBorrowerVersion fromLOS={true} />
        </Tab.Pane>
      </Tab.Content>

      <RightDrawer
        isOpen={rightDrawer}
        onClose={() => setRightDrawer(false)}
        onApplyParams={(paramsFromRightDrawer) => {
          console.log("rate quote new params: ", paramsFromRightDrawer);
          setParams(paramsFromRightDrawer);
          setRightDrawer(false);
        }}
      />

      <Modal
        open={addLenderModal}
        onCancel={() => setAddLenderModal(false)}
        centered
        footer={[
          <Button key="back" onClick={() => setAddLenderModal(false)}>
            Cancel
          </Button>,
        ]}
        width={1200}
      >
        <Lenders />
      </Modal>
    </Tab.Container>
  );

  return content;
};

export default withRouter(RateQuoter);
